// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_dhC","cls2":"CreateSocialItem-cls2_fMt CreateSocialItem-cls1_dhC"};